// extracted by mini-css-extract-plugin
export default {"root":"Page_root__916Qw","body":"Page_body__iTNC2"};